export const EMPTY_DROPDOWN_VALUE = {
  value: '',
  viewValue: 'Select',
};
